import React from 'react';
import * as Inovx from '@shared';
import UserStore from '../stores/UserStore';
import UserActions from '../actions/UserActions';
import UserConstants from '../constants/UserConstants';


var InovxControls = Inovx.Shared.Controls;
var CommonMessages = Inovx.Shared.Common.CommonMessages;

declare var InovxLoader:any;

interface UserSelectProps {
    onSelect: (user: IUser) => void;
    onCancel: () => void;
}

interface UserSelectState {
    validation?: IValidationDictionaryObject;
    Users: IUser[];
    searchString: string;
    selectedUser: IUser;
    showValidationWarning: boolean;
}


function getBlankValidation(): IValidationObject {
    return { invalidInput: false, invalidValue: false, invalidInputMessage: "", invalidValueMessage: "" };
}

function getState(): UserSelectState {
    return {
        validation: {
            "SearchString": getBlankValidation()
        },
        Users: [],
        searchString: "",
        selectedUser: null,
        showValidationWarning: false
    };
}

class UserSelect extends React.Component<UserSelectProps, UserSelectState> {

    constructor(props: UserSelectProps, context: any) {
        super(props, context);
        this.state = getState();
    }

    private _onRowSelect = (e: Event, user: IUser) => {
        this.setState((state) => ({
            selectedUser: user,
            showValidationWarning: (state.showValidationWarning && user) ? false : state.showValidationWarning
        }));
    }

    private _onOKClick = () => {
        if (this.state.selectedUser) {
            this.props.onSelect(this.state.selectedUser);
        }
        else {
            this.setState({
                showValidationWarning: true
            });
        }
    }

    private _onSearch = () => {
        if (this.state.searchString && !this.state.validation["SearchString"].invalidValue) {
            UserActions.getHint(this.state.searchString, () => {
                var users = UserStore.checkUser();
                this.setState({ Users: users });
            });
        }
    }

    private _onSearchChange = (event: any) => {
        this.setState({ searchString: event.target.value });
        this.setState((state) => {
            this._validateSearchString(state);
            return state;
        });
    }

    private _validateSearchString = (state: UserSelectState) => {
        if (!state.searchString) {
            state.validation["SearchString"].invalidValueMessage = CommonMessages.Validation.Required;
            state.validation["SearchString"].invalidValue = true;

            return false;
        } else {
            if (state.searchString.length < 3) {
                state.validation["SearchString"].invalidValueMessage = InovxLoader.t('users:form.searchStringTooShort');
                state.validation["SearchString"].invalidValue = true;
                return false;
            } else {
                state.validation["SearchString"].invalidValue = false;
                return true;
            }
        }
    }

    render() {
        var pagesize = 7;

        var columns = [{
            field: "UserName",
            headerText: InovxLoader.t('users:common.username')
        }, {
            field: "FirstName",
            headerText: InovxLoader.t('users:common.firstname')
        }, {
            field: "LastName",
            headerText: InovxLoader.t('users:common.lastname')
        }];

        var dataSource = this.state.Users;
        var defaultSort = [{
            field: "UserName",
            dir: "ascending"
        }];

        var searchInput = {
            className: 'form-control',
            type: 'text',
            name: 'SearchString'
        };

        return (
            <div className="panel panel-primary user-select">
                <div className="panel-heading">{InovxLoader.t('users:form.selectAccount')}</div>
                <div className="panel-body">
                    <div className='user-form'>
                        <Inovx.Shared.Controls.ActionInProgressLoader actionKey={[UserConstants.USER_CHECK_NAME]} class={'temp-modal-loader'}>
                            <div className="action-in-progress-loader-sm"></div>
                        </Inovx.Shared.Controls.ActionInProgressLoader>

                        <InovxControls.FormField title={""} tooltip={""} inputName='SearchString'>
                            <InovxControls.ValidationInput {...searchInput} value={this.state.searchString} className="form-control" onChange={this._onSearchChange} validation={this.state.validation["SearchString"]} readOnly={false} autofocus={true} />
                            <button id="User_Search_btn" onClick={this._onSearch} className='glyphicon glyphicon-search user-search-button'></button>
                        </InovxControls.FormField>
                        <Inovx.Shared.Controls.Grid dataSource={dataSource} selectRow={this._onRowSelect} reset={true} defaultSort={defaultSort}
                            columns={columns} sort={true} filter={false} scrollHeight={31 * pagesize} allowScrolling={true} autoSelectSingleRow={true} />
                        <div className="text-danger" style={{ paddingTop: "10px", display: (this.state.showValidationWarning) ? "" : "none" }}>{InovxLoader.t('users:form.selectAccountWarning')}</div>
                        <div className="btn-bar-b-sm">
                            <button type="button" className="btn btn-primary" onClick={this._onOKClick}>{InovxLoader.t('users:form.ok')}</button>
                            <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{InovxLoader.t('users:form.cancel')}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserSelect;
